/* eslint-disable jsx-a11y/anchor-is-valid */
import {useAuth} from '@/app/modules/auth'
import {useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import {MenuComponent} from '../../../assets/ts/components'
import {KTIcon} from '../../../helpers'
import {HeaderUserMenu, ThemeModeSwitcher} from '../../../partials'
import {useLayout} from '../../core'
import {DefaultTitle} from './page-title/DefaultTitle'

const HeaderToolbar = () => {
  const {classes} = useLayout()
  const location = useLocation()
  const {currentUser, logout} = useAuth()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [location])

  return (
    <div className='toolbar d-flex flex-wrap align-items-stretch mt-3 mt-md-4'>
      <div
        className={`
          ${classes.headerContainer.join(' ')}
          py-4 py-lg-0
          d-flex flex-column flex-lg-row
          align-items-start align-items-lg-center
          justify-content-between
          gap-3 gap-lg-0
          w-100
        `}
      >
        {/* Left section - Page title */}
        <div className='flex-grow-1 text-center text-lg-start'>
          <DefaultTitle />
        </div>

        {/* Right section - Outlet info & user */}
        <div className='d-flex flex-wrap flex-lg-nowrap align-items-center justify-content-center justify-content-lg-end gap-4'>
          {/* Outlet Info */}
          <div className='d-flex align-items-center text-center text-lg-start'>
            <KTIcon iconName='geolocation' className='fs-2 me-2 text-primary' />
            <div className='d-flex flex-column'>
              <span className='text-muted small'>Outlet anda saat ini,</span>
              <span className='fw-bold'>{currentUser?.detail_data?.outlet?.outlet_name}</span>
            </div>
          </div>

          {/* User Profile */}
          <div className='aside-user d-flex align-items-center justify-content-center'>
            <a
              href='#'
              className='symbol symbol-50px'
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-overflow='false'
            >
              <img src={currentUser?.detail_data?.url_profile_picture} alt='' />
            </a>
            <HeaderUserMenu />
          </div>
        </div>
      </div>
    </div>
  )
}

export {HeaderToolbar}
